export {IconButton, IconButton as default} from './icon-button.component';
export {BasicIconButton} from './basic-icon-button.component';

export {SIZES} from './constants';

export type {IconButtonProps} from './icon-button.component';
export type {BasicIconButtonProps} from './basic-icon-button.component';
export type {SizeType} from './constants';
